import { ReactComponent as Apex } from "../../assets/game-icons/apex.svg"
import { ReactComponent as ArcRaiders } from "../../assets/game-icons/arc-raiders.svg"
import { ReactComponent as Battlefield6 } from "../../assets/game-icons/battlefield6.svg"
import { ReactComponent as Cfb } from "../../assets/game-icons/cfb.svg"
import { ReactComponent as ClashRoyale } from "../../assets/game-icons/clash-royale-light.svg"
import { ReactComponent as CodBo1 } from "../../assets/game-icons/codbo1.svg"
import { ReactComponent as CodBo2 } from "../../assets/game-icons/codbo2.svg"
import { ReactComponent as CodBo6 } from "../../assets/game-icons/codbo6-light.svg"
import { ReactComponent as CodBo7 } from "../../assets/game-icons/codbo7.svg"
import { ReactComponent as CodMw } from "../../assets/game-icons/codmw.svg"
import { ReactComponent as CodWz } from "../../assets/game-icons/codwz.svg"
import { ReactComponent as Counterstrike } from "../../assets/game-icons/counterstrike.svg"
import { ReactComponent as DefaultGame } from "../../assets/game-icons/default.svg"
import { ReactComponent as Dota } from "../../assets/game-icons/dota.svg"
import { ReactComponent as Eafc } from "../../assets/game-icons/eafc.svg"
import { ReactComponent as Fortnite } from "../../assets/game-icons/fortnite.svg"
import { ReactComponent as Halo } from "../../assets/game-icons/halo.svg"
import { ReactComponent as LeagueOfLegends } from "../../assets/game-icons/league_of_legends.svg"
import { ReactComponent as Madden } from "../../assets/game-icons/madden.svg"
import { ReactComponent as MarvelRivals } from "../../assets/game-icons/marvel-rivals.svg"
import { ReactComponent as Mlb } from "../../assets/game-icons/mlb.svg"
import { ReactComponent as Multiversus } from "../../assets/game-icons/multiversus.svg"
import { ReactComponent as Nba2k } from "../../assets/game-icons/nba2k.svg"
import { ReactComponent as Rainbow6 } from "../../assets/game-icons/rainbow6.svg"
import { ReactComponent as RocketLeague } from "../../assets/game-icons/rocket-league.svg"
import { ReactComponent as Valorant } from "../../assets/game-icons/valorant.svg"

const GAME_ICON_COMPONENTS = {
  apex: Apex,
  arc_raiders: ArcRaiders,
  battlefield6: Battlefield6,
  cfb: Cfb,
  clash_royale: ClashRoyale,
  codbo1: CodBo1,
  codbo2: CodBo2,
  codbo6: CodBo6,
  codbo7: CodBo7,
  codmw: CodMw,
  codwz: CodWz,
  counterstrike: Counterstrike,
  default: DefaultGame,
  dota: Dota,
  eafc: Eafc,
  fortnite: Fortnite,
  halo: Halo,
  league_of_legends: LeagueOfLegends,
  madden: Madden,
  marvel_rivals: MarvelRivals,
  mlb: Mlb,
  multiversus: Multiversus,
  nba2k: Nba2k,
  rainbow6: Rainbow6,
  rocket_league: RocketLeague,
  valorant: Valorant,
}

type GameIconKey = keyof typeof GAME_ICON_COMPONENTS

// ported from plc-app's design system: src/lib/design-system/iconography/iconography.tsx (gameIconMap)
const gameIconKey = (systemId?: string | null): GameIconKey => {
  switch (systemId) {
    case 'codwz':
    case 'codwz2':
      return 'codwz'
    case 'codmw2':
    case 'codmw3':
      return 'codmw'
    case 'apex':
      return 'apex'
    case 'arc_raiders':
      return 'arc_raiders'
    case 'valorant':
    case 'vlrt':
      return 'valorant'
    case 'csgo':
    case 'csgo2':
    case 'cs2':
      return 'counterstrike'
    case 'halo':
      return 'halo'
    case 'league_of_legends':
      return 'league_of_legends'
    case 'fortnite':
      return 'fortnite'
    case 'multiversus':
      return 'multiversus'
    case 'clash_royale':
      return 'clash_royale'
    case 'rocket_league':
      return 'rocket_league'
    case 'nba2k25':
    case 'nba2k26':
    case 'nba2k27':
      return 'nba2k'
    case 'madden25':
    case 'madden26':
    case 'madden27':
      return 'madden'
    case 'eafc25':
    case 'eafc26':
      return 'eafc'
    case 'cfb25':
    case 'cfb26':
    case 'cfb27':
      return 'cfb'
    case 'marvel_rivals':
      return 'marvel_rivals'
    case 'battlefield6':
      return 'battlefield6'
    case 'codbo1':
      return 'codbo1'
    case 'codbo2':
      return 'codbo2'
    case 'codbo6':
      return 'codbo6'
    case 'codbo7':
      return 'codbo7'
    case 'mlbtheshow26':
      return 'mlb'
    case 'r6_siege':
      return 'rainbow6'
    case 'dota2':
      return 'dota'
    default:
      return 'default'
  }
}

export const GameIcon = ({ systemId, size = 24, color = 'currentColor' }: { systemId?: string | null, size?: number, color?: string }) => {
  const Icon = GAME_ICON_COMPONENTS[gameIconKey(systemId)]
  return <Icon width={size} height={size} fill={color} />
}
